import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    ADD_TAG_CONVERSATION_REQUEST,
    ADD_TAG_CONVERSATION_SUCCESS,
    ADD_TAG_CONVERSATION_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const AddTagConversationAction = (cvId,dataTarget) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/conversations/${cvId}`;
        },
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(dataTarget);
        }),
        types: [
            ADD_TAG_CONVERSATION_REQUEST,
            {
                type: ADD_TAG_CONVERSATION_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": ADD_TAG_CONVERSATION_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: ADD_TAG_CONVERSATION_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": ADD_TAG_CONVERSATION_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {AddTagConversationAction}